'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TRUTRAVELS_PARTICIPATION_WAIVER = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRUTRAVELS_PARTICIPATION_WAIVER = exports.TRUTRAVELS_PARTICIPATION_WAIVER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formParticipationWaiver.stubText.TT',
    defaultMessage: '{waiverText}',
    values: {
        waiverText: _react2.default.createElement(
            'div',
            { className: 'waiver-text' },
            _react2.default.createElement(
                'h2',
                { className: 'h2-size center-text hero-text' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part1.title.TT',
                    defaultMessage: 'TruTravels Waiver Of Liability' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'waiver-intro' },
                _react2.default.createElement(
                    'p',
                    { className: 'subheading' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formParticipationWaiver.part1.title1.TT',
                        defaultMessage: 'By agreeing to the terms of this agreement you will waive certain legal rights.' })
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'subheading no-pad' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(
                            'em',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part1.title2.TT',
                                defaultMessage: 'Please read carefully' })
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formParticipationWaiver.part1.text1.TT',
                    defaultMessage: 'This waiver of liability agreement (hereafter \u201CWaiver\u201D) is between you (hereafter \u201CI\u201D, \u201Cme\u201D, \u201Cmy\u201D), and {bold1}, and its subsidiaries, affiliates, and related companies and their respective directors, officers, employees, subcontractors, suppliers, agents, guides, volunteers, independent contractors, representatives, owners, insurers, successors, and assigns (individually and collectively, {bold2})',
                    values: {
                        bold1: _react2.default.createElement(
                            'strong',
                            null,
                            'TruTravels Limited'
                        ),
                        bold2: _react2.default.createElement(
                            'strong',
                            null,
                            'TRUTRAVELS'
                        )
                    }
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'simply-put' },
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part1.text2.TT.title',
                        defaultMessage: 'What this means:' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part1.text2.TT.description',
                        defaultMessage: 'I am providing this Waiver to the companies and people involved in organizing and providing the services & activities that I have requested in connection with my travel arrangements.' })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'waiver-intro' },
                _react2.default.createElement(
                    'p',
                    { className: 'subheading' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formParticipationWaiver.part2.title1.TT',
                        defaultMessage: '"{boldText}" means the activities and services that TruTravels will be providing, arranging, or organizing on my behalf depending on my chosen itinerary.',
                        values: { boldText: _react2.default.createElement(
                                'strong',
                                null,
                                'Activities'
                            ) }
                    })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text1.TT',
                        defaultMessage: ' These may include: ' })
                ),
                _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text2.TT',
                            defaultMessage: 'participation in a group travel tour' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text3.TT',
                            defaultMessage: 'Canyoneering' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text4.TT',
                            defaultMessage: 'Caving' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text5.TT',
                            defaultMessage: 'Cycling' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text6.TT',
                            defaultMessage: 'Hang-gliding' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text7.TT',
                            defaultMessage: 'Horse riding and other equine activities' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text8.TT',
                            defaultMessage: 'Water parks' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text9.TT',
                            defaultMessage: 'Mountain biking' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text10.TT',
                            defaultMessage: 'Parasailing' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text11.TT',
                            defaultMessage: 'rock/rope climbing' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text12.TT',
                            defaultMessage: 'rappelling' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text13.TT',
                            defaultMessage: 'Zip lining' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text14.TT',
                            defaultMessage: 'Scuba diving' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text15.TT',
                            defaultMessage: 'Snorkeling' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text16.TT',
                            defaultMessage: 'White water rafting' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text17.TT',
                            defaultMessage: 'Travel in jet boats/speed boats' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text18.TT',
                            defaultMessage: 'Trekking' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text19.TT',
                            defaultMessage: 'Trekking' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text20.TT',
                            defaultMessage: 'mountaineering' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text21.TT',
                            defaultMessage: 'Surfing' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text22.TT',
                            defaultMessage: 'Cooking' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text23.TT',
                            defaultMessage: 'Travel by motorized vehicle or train or other forms of public and private transportation' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part2.text24.TT',
                            defaultMessage: 'Martial arts training' })
                    )
                ),
                _react2.default.createElement(
                    'h2',
                    { className: 'h2-size' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.title1.TT',
                        defaultMessage: 'ACKNOWLEDGMENT \u2013 HEALTH & SAFETY' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text1.TT',
                        defaultMessage: 'I am aware that the physical exertion required to participate in the Activities can activate or aggravate pre-existing injuries, conditions, or congenital defects ' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text2.TT',
                        defaultMessage: 'I acknowledge that I should seek medical advice if I know or suspect that my physical condition may be incompatible with the Activities.' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text3.TT',
                        defaultMessage: 'I acknowledge that I am required to wear approved safety equipment while participating in certain Activities. I am aware that there are guides and instructors available to answer any questions I may have as to the proper use of any equipment.' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'simply-put' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text4.TT',
                            defaultMessage: 'What this means:' })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part3.text5.TT',
                            defaultMessage: 'I understand that the Activities may require physical exertion and it is my responsibility to make sure I am healthy enough to participate. I will use the recommended safety equipment and ask questions if I am unsure about how to properly or safely use equipment. ' })
                    )
                ),
                _react2.default.createElement(
                    'h2',
                    { className: 'h2-size' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.title1.TT',
                        defaultMessage: 'ASSUMPTION OF RISKS' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text1.TT',
                        defaultMessage: 'I am aware that the Activities involve many risks, dangers and hazards which may include but are not limited to:' })
                ),
                _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text2.TT',
                            defaultMessage: 'personal injury and/or death;' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text3.TT',
                            defaultMessage: 'travel to remote areas without access to medical facilities or treatment' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text4.TT',
                            defaultMessage: 'changing weather conditions;' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text5.TT',
                            defaultMessage: 'interactions or encounters with wildlife; ' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text6.TT',
                            defaultMessage: 'equipment malfunctions' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text7.TT',
                            defaultMessage: 'negligence of other participants or guides;' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text8.TT',
                            defaultMessage: 'negligence on the part of the TruTravels, including failure to safeguard or protect from the risks or dangers of the Activities' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text9.TT',
                            defaultMessage: 'consumption of alcohol;' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text10.TT',
                            defaultMessage: 'collisions with vehicles, equipment or structures;' })
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text11.TT',
                            defaultMessage: 'becoming lost or separated from guides or other participants; and the failure to remain within designated areas.' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'simply-put' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text12.TT', defaultMessage: 'What this means:' })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part4.text13.TT',
                            defaultMessage: 'I acknowledge that there are numerous risks I may face during my involvement in the Activities including the risks listed here.' })
                    )
                ),
                _react2.default.createElement(
                    'h2',
                    { className: 'h2-size' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.title1.TT',
                        defaultMessage: 'ALCOHOL AND ILLEGAL SUBSTANCES' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text1.TT',
                        defaultMessage: 'If I use, consume or am under the influence of alcohol or illegal drugs prior to or while engaging in the Activities,' }),
                    '\xA0',
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text2.TT',
                            defaultMessage: 'I ASSUME AND ACCEPT ALL RISKS, DANGERS AND HAZARDS THAT MAY RESULT FROM THIS INCLUDING THE POSSIBILITY OF PERSONAL INJURY, DEATH, PROPERTY DAMAGE AND LOSS' })
                    ),
                    '\xA0',
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text3.TT',
                        defaultMessage: ', even in the event of negligence or fault by TruTravels or third parties, and will indemnify TruTravels from any and all liability for any damage to property or personal injury to any third party, resulting from my participation in the Activities, while, during or after consumption of illegal drugs or alcohol.' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'simply-put' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text4.TT', defaultMessage: 'What this means:' })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part5.text5.TT',
                            defaultMessage: 'If I consume alcohol or illegal drugs before or during my involvement in the Activities I am responsible for any loss, injury or damage I cause to myself or others.' })
                    )
                ),
                _react2.default.createElement(
                    'h2',
                    { className: 'h2-size' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.title1.TT',
                        defaultMessage: 'I AM AWARE OF THE RISKS, DANGERS, AND HAZARDS ASSOCIATED WITH THE ACTIVITIES.' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.text1.TT',
                        defaultMessage: 'I am not relying on any oral or written representations or statements made by TruTravels about the safety of the Activities other than what is stated in this Waiver. ' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.text2.TT',
                            defaultMessage: 'I freely accept and fully assume these risks and the possibility of injury and loss resulting from my participation in the Activities.' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'simply-put' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.text3.TT', defaultMessage: 'What this means:' })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part6.text4.TT',
                            defaultMessage: 'I understand and accept the risks of participating in the Activities. I am relying on the statements about the risk contained in this Wavier as the definitive source of information about the safety of the Activities over any other communications or materials.' })
                    )
                ),
                _react2.default.createElement(
                    'h2',
                    { className: 'h2-size' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.title1.TT',
                        defaultMessage: 'RELEASE OF LIABILITY, WAIVER OF CLAIMS, AND INDEMNITY AGREEMENT' })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text1.TT',
                        defaultMessage: 'In consideration of TRUTRAVELS allowing me to participate in the Activities I agree:' })
                ),
                _react2.default.createElement(
                    'ol',
                    null,
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text2.TT',
                                defaultMessage: 'In the event that I, or my next of kin, suffer any loss, damage, expense or injury from my participation in the Activities' }),
                            '\xA0',
                            _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text3.TT',
                                    defaultMessage: 'INCLUDING THOSE CAUSED BY THE RISKS SPECIFICALLY OUTLINED IN THIS WAIVER, I AGREE TO WAIVE ANY AND ALL CLAIMS' })
                            ),
                            '\xA0',
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text4.TT',
                                defaultMessage: 'I have or may have in the future against' }),
                            '\xA0',
                            _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text5.TT',
                                    defaultMessage: 'TRUTRAVELS' })
                            ),
                            '\xA0',
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text6.TT',
                                defaultMessage: 'and to' }),
                            '\xA0',
                            _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text7.TT',
                                    defaultMessage: 'RELEASE TRUTRAVELS' })
                            ),
                            '\xA0',
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text8.TT',
                                defaultMessage: 'from any and all liability;' })
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text9.TT',
                                    defaultMessage: 'TO HOLD HARMLESS AND INDEMNIFY TRUTRAVELS' })
                            ),
                            '\xA0',
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text10.TT',
                                defaultMessage: 'from any and all liability for damage to property or personal injury to any third party resulting from my participation in the Activities;' })
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text12.TT',
                                defaultMessage: 'This Agreement shall be effective and binding upon my heirs, next of kin, executors, administrators, assigns and representatives, in the event of my death or incapacity.' })
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part7.text13.TT',
                                defaultMessage: 'This agreement and any dispute or claim arising out of or in connection with its subject matter or formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with the law of England and Wales.' })
                        )
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formParticipationWaiver.part8.text1.TT',
                            defaultMessage: 'I HAVE READ AND UNDERSTAND THIS AGREEMENT PRIOR TO CHECKING THE BOX BELOW CONFIRMING MY AGREEMENT.' })
                    )
                )
            )
        )
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/Waiver_TruTravels.js
// module id = 1333
// module chunks = 0